module.exports = "./img/843f81f127ab485b7f499aebd76702c8.png";